<template>
  <div class="cmp-catalog-tracks-tracks_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img
            @click="onAddTracksListClick"
            class="dt-icon v5 s1"
            src="static/buttons/add.svg"
            alt
          />
        </div>
      </div>
      <div class="search" style="max-width: 200px">
        <InputField
          :value="basicFilter.searchString"
          :placeholder="$t('search')"
          :config="{
            borderStyle: 'bottom',
            maxWidth: '200px',
            minWidth: '200px',
            width: '200px',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>

      </div>
      <div class="dropdown-area">
        <!-- <Dropdown
          :options="artistsTV"
          :selected="artistsTV.find(a => a.value == basicFilter.artist)"
          :placeholder="'Select Artist'"
          deselect
          borderbottom
          @selectedChange="e => onDropdownChange('artist', e)"
        ></Dropdown>-->

        <Dropdown
          :options="digitalRightTpyesTV"
          :selected="
            digitalRightTpyesTV.find(
              (x) => x.value == basicFilter.digital_right
            )
          "
          deselect
          :placeholder="$t('select_digital_right')"
          borderbottom
          @selectedChange="(e) => onDropdownChange('digital_right', e)"
        ></Dropdown>
        <DTCheckbox
          style="margin-left: 10px"
          :id="'barcode_catalog_error'"
          :label="'!!!'"
          :checked="basicFilter.isrc_check"
          @click="isrcCheckClicked"
          :h="'auto'"
        />
      </div>
      <DTIconButton
          :classNames="'search--advanced'"
          :text="'Advanced Search'"
          :style="{
            minWidth: '148px',
          }"
          icon="add-blue"
          @click="onAdvancedSearchClick"
        />
      <div class="search-config--container">
        <div class="search-config">
          <SearchConBadge
            v-for="sconKey of filteredAdvancedSearchConfigKeys"
            :key="sconKey"
            v-bind="searchConfigKey(sconKey)"
            @delete="onSearchConDelete"
          />
        </div>
      </div>
    </div>
    <div class="dt-page--body">
      <NTable
        id="catalog-product_groups-product_group_list"
        class="h1"
        :config="tableConfig"
        :headers="headers"
        :items="list"
        @scrollnext="onTrackScroll"
        :loadingFlag="loadingFlag"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr
            :class="{
              selected: selectedRow(item),
            }"
            @click="onTracksClicked(item)"
            :title="$t('click_to_see_tracks_list')"
          >
            <td v-bind="tdcon('tracks')">
              <span class="txtov" :title="item['title']">{{
                item["title"]
              }}</span>
            </td>
            <td v-bind="tdcon('version')">
              <span class="txtov" :title="item['version']">{{
                item["version"]
              }}</span>
            </td>
            <td v-bind="tdcon('artist')">
              <span class="txtov" :title="item['artist']">{{
                item["artist"]
              }}</span>
            </td>
            <td v-bind="tdcon('isrc')">
              <div class="ut-flex">
                <span class="txtov" :title="item['isrc']">{{
                  item["isrc"]
                }}</span>
                <b
                  @click.stop="onISRCClick(item)"
                  class="ut-text-accent"
                  style="margin-left: 3px"
                  v-if="item['verify_isrc']"
                  >!!!</b
                >
              </div>
            </td>
            <td v-bind="tdcon('main_catalog_no')">
              <div class="ut-flex">
                <span class="txtov" :title="item['catalog_no']">{{
                  item["catalog_no"]
                }}</span>
                <b
                  :title="
                    item.main_product > 0
                      ? $t('product_track_mismatch')
                      : ''
                  "
                  @click.stop="onMainCatalogClick(item)"
                  v-if="catalogVerify(item)"
                  class="ut-text-accent"
                  style="margin-left: 3px"
                  >!!!</b
                >
              </div>
            </td>
            <td v-bind="tdcon('licensors')">
              <span class="txtov" :title="item['licensors']">{{
                item["licensors"]
              }}</span>
            </td>
            <td v-bind="tdcon('type')">
              <div>
                <TrackType :type="item['type']" />
                <!-- <span
                  style="
                    margin: 0px auto;
                    padding: 3px 8px;
                    border-radius: 15px;
                    text-transform: capitalize;
                  "
                  :style="typeStyle(item)"
                  :title="item['type']"
                  >{{ item["type"] }}</span
                > -->
              </div>
            </td>
            <td v-bind="tdcon('options')">
              <img
                src="static/icons/delete.svg"
                @click.stop="(e) => onTrackDelete(item)"
                class="dt-icon v5 s2 ut-center"
                alt
              />
            </td>
          </tr>
        </template>
      </NTable>
    </div>

    <Sidewindow
      :navConfig="defaultConfig"
      :value="tracksDetailsFlag"
      @closed="onCloseTracksDetails"
    >
      <TracksSidewindow />
    </Sidewindow>

    <ModalContainer :modalKey="'advancedSearch'" :width="'550'">
      <AdvancedSearch
        :advancedSearchData="advancedSearchData"
        :initSearchFilter="searchFilter"
        @search="onAdvancedSearch"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'newTrack'" :width="'small'">
      <NewTrack @cancelled="onDialogCancelled" @added="onAdded" />
    </ModalContainer>
    <ModalContainer :modalKey="'isrcAlertModal'" :width="'medium'">
      <ISRCAlertModal
        :selectedTrack="selectedClickedTrack"
        @cancelled="onDialogCancelled"
        @changed="onTextFieldValueChange"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'mainCatalogAlertModal'" :width="'medium'">
      <MainCatalogAlertModal
        :selectedTrack="selectedClickedTrack"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>
  </div>
</template>

<script>
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import InputField from "@plugins/text-field/input-field";
import { DTIconButton } from "../../../../plugins/button/button";
import Dropdown from "@plugins/dropdown/dropdown";
import NTable from "@/plugins/datatable/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";
import * as ActionTypes from "../../store/types";
import { CatalogStoreNamespace as storeNS } from "../../store";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import Sidewindow from "@/dt-plugins/sidewindow/sidewindow";
import DTCheckbox from "../../../../plugins/checkbox/checkbox";

import {
  childOfOrEqualDetails,
  handleFromRoute,
} from "../../../../utility/route";

import {
  getTracksDetailsSelectable,
  tracksListLDTRoutes,
} from "../../router/routes";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { tracksCatalogActions } from "../../store/tracks/actions";
import { tracksCatalogGetters } from "../../store/tracks/getters";
import { createTV } from "../../../../models/text-value.model";
import { TracksService } from "../../services/tracks.service";
import {
  sendMail,
  subscribeSubject,
  subscribeSubjectND,
} from "../../../../utility";
import { Subject } from "rxjs";
import { createModalMixin } from "../../../../dt-plugins/modal/modal.mixin";

import AdvancedSearch from "./advanced-search";
import NewTrack from "./new-track";
import ISRCAlertModal from "./ISRC-alert-modal.vue";
import MainCatalogAlertModal from "./main-catalog-alert-modal.vue";
import { async } from "rxjs/internal/scheduler/async";

import TracksSidewindow from "./tracks-sidewindow";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";
import { createAdvancedSearchHost } from "../../../../dt-plugins/advanced-search/advance-search.mixin";
import { trackListAdvancedSearchConfig } from "./advanced-search.vue";
import {
  confirmMessage,
  confirmWarning,
  confirmError,
  confirmOK,
} from "../../../../dt-plugins/confirmation/confirmation-common";
import { TrackType } from "../../../../dt-plugins/tracks/track-type";

const listLength = 100;

const LDTConfig = {
  entityName: "track",
  ldtRoutes: tracksListLDTRoutes,
  detailsSelectableFunction: getTracksDetailsSelectable,
  primaryKey: "track_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.TrackDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.TrackDetails.FETCH.SINGLE,
};

export default {
  components: {
    InputField,
    DTIconButton,
    Dropdown,
    NTable,
    ModalContainer,
    AdvancedSearch,
    NewTrack,
    Sidewindow,
    TracksSidewindow,
    DTCheckbox,
    ISRCAlertModal,
    MainCatalogAlertModal,
    TrackType,
  },
  data: function () {
    return {
      defaultConfig: defaultConfig,
      getTracksDetailsSelectable: getTracksDetailsSelectable,
      selectedClickedTrack: null,
    };
  },
  // mounted: async function () {},
  mixins: [
    createLDTHost(LDTConfig),
    createModalMixin("advancedSearch"),
    createModalMixin("newTrack"),
    createModalMixin("isrcAlertModal"),
    createModalMixin("mainCatalogAlertModal"),
    createFetchListMixin(ActionTypes.TrackList.FETCH.ALL),
    createAdvancedSearchHost(trackListAdvancedSearchConfig),
  ],
  computed: {
    ...mapGetterObject(storeNS, tracksCatalogGetters),
    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
      });
    },
    list: function () {
      return this.trackList?.tracks || [];
      // return this.trackList && this.trackList.tracks || [];
    },
    artistsTV: function () {
      return (
        createTV(this.artists, "artist", "artist").filter(
          (e) => e.text != ""
        ) || []
      );
    },
    digitalRightTpyesTV: function () {
      return createTV(this.trackList?.digital_right_types, "value", "index");
    },
    headers: function () {
      return [
        createTableHeader("tracks", { fw: 700 }),
        createTableHeader("version"),
        createTableHeader("artist"),
        createTableHeader("isrc"),
        createTableHeader("main_catalog_no"),
        createTableHeader("licensors"),
        createTableHeader("type", { text: false, f: 0.5, ta: "center" }),
        createTableHeader("options", { text: false, mw: 40 }),
      ];
    },
    artists: function () {
      return (this.trackList && this.trackList.artists) || [];
    },

    filter: function () {
      return {
        ...this.metaFilter,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter,
      };
    },
    tracksDetailsFlag: function () {
      return childOfOrEqualDetails(tracksListLDTRoutes, this.$route);
    },
    advancedSearchData: function () {
      return {
        digitalRightTpyesTV: createTV(
          this.trackList?.digital_right_types,
          "value",
          "index"
        ),
        tracksTypeTV: [
          { text: "Audio", value: "audio" },
          { text: "Video", value: "video" },
          { text: "Mix", value: "mix" },
        ],
        genresTV: createTV(
          this.advancedSearchResponse?.genres,
          "genre_name",
          "genre_id"
        ),
        licensorsTV: createTV(
          this.advancedSearchResponse?.licensors,
          "licence_account_name",
          "licence_account_id"
        ),
        labelsTV: createTV(
          this.advancedSearchResponse?.labels,
          "label_name",
          "label_id"
        ),
        royaltyPeriodsTV: createTV(
          this.advancedSearchResponse?.royalty_periods,
          "label",
          "value"
        ),
        royaltyInvoiceProjectTV: createTV(
          this.advancedSearchResponse?.invoice_projects,
          "invoice_project_name",
          "invoice_project_id"
        ),
        royaltyAccountsTV: createTV(
          this.advancedSearchResponse?.royalty_accounts,
          "royalty_account_name",
          "royalty_account_id"
        ),
        metaDataTV: createTV(
          this.advancedSearchResponse?.metadata_objects.map(
            (e) => `${e?.metadata_endpoint}.${e?.meta_name}`
          )
        ),
      };
    },
  },
  methods: {
    ...mapActionObject(storeNS, tracksCatalogActions),
    // fetchList: function () {
    //   this.startFrom = 0;
    //   this[ActionTypes.TrackList.FETCH.ALL](this.filter);
    // },
    // fetchListNext: function () {
    //   this[ActionTypes.TrackList.FETCH.ALL](this.filter);
    // },
    // onSearchInputKeyup: function (event) {
    //   this.searchString = event.target.value;
    //   // console.log('Search String', this.searchString, event.target.value);
    //   this.searchSubject.next(this.searchString);
    // },
    defaultBasicFilter() {
      return {
        searchString: "",
        artist: undefined,
        digital_right: undefined,
        isrc_check: false,
      };
    },
    fetchAdvancedSearchData: async function () {
      const advancedSearchData = await TracksService.advancedSearch();
      this.advancedSearchResponse = advancedSearchData.data;
      // console.log({
      //   "this.advancedSearchResponse": this.advancedSearchResponse,
      // });
    },
    onDropdownChange(name, value) {
      this.basicFilter[name] = value.value;
      this.fetchListReset();
    },
    onTextFieldValueChange: async function (event) {
      console.log("eventevent", event);
      const { name, value, kVal } = event;
      await TracksService.modify({
        name,
        value,
        kVal,
      });
      this.fetchListReset();
    },
    onAdvancedSearchClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "advanced_search",
        },
      });
    },
    onAddTracksListClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "new_track",
        },
      });
    },
    onMainCatalogClick: function (track) {
      if (track.main_product > 0) {
        return;
      }
      this.selectedClickedTrack = track;
      this.$router.push({
        ...this.$route,
        query: {
          modal: "main_catalog_alert_modal",
          track_id: track.track_id,
        },
      });
    },
    onISRCClick: async function (track) {
      // console.log("track", track);
      if (track.isrc && !track.invalid_length) {
        this.selectedClickedTrack = track;
        this.$router.push({
          ...this.$route,
          query: {
            modal: "isrc_alert_modal",
            track_id: track.track_id,
          },
        });
      } else if (track?.invalid_length > 0) {
        const confirmationResult = await confirmOK("Invalid ISRC");
      } else {
        const confirmationResult = await confirmOK("Missing ISRC");
      }
    },
    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onCloseTracksDetails: function () {
      this.selectedClickedTrack = null;
      handleFromRoute(this, () => {
        this.$router.push({
          name: tracksListLDTRoutes.names.list,
        });
      });
    },
    onTracksClicked: function (track) {
      this.selectedClickedTrack = track;
      this.$router.push({
        name: tracksListLDTRoutes.names.tab,
        params: {
          track_id: track.track_id,
          tab: "overview",
        },
      });
    },
    onTrackScroll: function (value) {
      // console.log("Track Scroll");
      this.scrollSubject.next(value);
    },
    onTrackDelete: async function (item) {
      // console.log("delete me tc ", item);
      const confirmationResult = await confirmDelete("Track", item.title);
      if (confirmationResult === "OK") {
        this[ActionTypes.TrackList.DELETE.SINGLE](item);
      }
    },
    selectedRow: function (track) {
      return (
        this.selectedClickedTrack &&
        this.selectedClickedTrack["track_id"] == track["track_id"]
      );
    },
    onAdded: function (payload) {
      // console.log("onAdded payload", payload);

      this[ActionTypes.TrackList.SET.ALL](payload);
      this.onDialogCancelled();
    },

    isrcCheckClicked(event) {
      this.basicFilter.isrc_check = event.target.checked;
      this.resetSearchFilter();
      this.fetchListReset();
    },
    catalogVerify(item) {
      const { main_product, main_product_track, other_product_track } = item;
      if (!main_product) {
        return true;
      } else if (main_product && !main_product_track && other_product_track) {
        return true;
      } else {
        return false;
      }
    },
    typeStyle({ type }) {
      if (type == "Audio") {
        return {
          background: "#7878F080",
        };
      } else if (type == "video") {
        return {
          background: "#64C89680",
        };
      } else if (type == "mix") {
        return {
          background: "#FF6E6E80",
        };
      }
    },

    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-catalog-tracks-tracks_list {
  .dt-page--body {
    --offset: 120px;
  }
  .dt-page--top-bar {
    .dropdown-area {
      display: flex;
      .dropdown {
        width: 190px;
        margin-right: 10px;
      }
    }
    .dt-checkbox-control {
      .dt-checkbox-label-container {
        .dt-checkbox-label {
          color: var(--text-accent);
          font-weight: 500;
        }
      }
    }
  }
}
</style>
